import { createStore, combineReducers } from 'redux';

import grantRequest from './ducks/grant_request.js'
import lineItems from './ducks/line_items.js'
import attachments from './ducks/attachments.js'
import emailsToNotify from './ducks/emails_to_notify.js'
import wizard from './ducks/wizard.js'
import rails from './ducks/rails.js'
import submissionErrors from './ducks/submission_errors.js'

/* WARNING - this does not support thunks */
const handleBatches = (combined) => (state = {}, action) => {
  switch (action.type) {
    case 'INITIAL_LOAD_OF_DATA_FROM_RAILS':
    case 'RAILS_UPDATE_SUCCEEDED':
    case 'RAILS_UPDATE_FAILED': {
      return action.actions.reduce((collectedState, batchedAction) => {
        return combined(collectedState, batchedAction)
      }, { ...state })
    }

    default: { return combined(state, action) }
  }
}

const store = createStore(
  handleBatches(
    combineReducers({
      rails,
      wizard,
      grantRequest,
      emailsToNotify,
      lineItems,
      attachments,
      submissionErrors
    })
  ),

  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

export default store
